import { NgModule } from '@angular/core'
import { ScriptSources, ScriptsService } from './scripts.service'

const sources: ScriptSources = {
  links: [
    {
      rel: 'preconnect',
      href: '//privacy-proxy.usercentrics.eu'
    },
    {
      rel: 'preload',
      href: '//privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js',
      as: 'script'
    }
  ],
  scripts: [
    {
      id: 'usercentrics-cmp',
      src: 'https://app.usercentrics.eu/browser-ui/latest/loader.js',
      defer: true,
      dataset: {
        rulesetId: 'y5Xan7ft6'
      }
    }
  ]
}

@NgModule()
export class ScriptsModule {

  constructor (scriptService: ScriptsService) {
    scriptService.init(sources)
  }
}
